/**
 * DependencyEdge — React Flow custom edge for a MERODE dependency (phase 6b).
 *
 * Pixel-faithful port of `components/EDG/dependency.js`. The marker selection,
 * label list and rounded boundary-anchored path are all derived in
 * `EdgFlow.deriveEdges` (see `edgeMapping.ts`) and passed via `data`; this
 * component is the thin React Flow renderer (delegates to EdgeBase). It exists as
 * a NAMED edge type so `edgeTypes.dependency` maps to dependency-specific
 * geometry, matching the old EDG's separate `<Dependency>` component.
 *
 * Marker semantics replicated from `dependency.js`:
 *  - MERODE notation only: source marker = optional (○) / mandatory (●) from the
 *    first half of the type; target marker = many (➤) from the second half.
 *  - UML notation: NO markers; cardinality is shown as labels instead.
 *
 * Classic JSX runtime (app-wide esbuild transform) needs React in scope.
 */
import React from 'react';
import type { EdgeProps } from '@xyflow/react';
import EdgeBase, { type EdgeFlowEdge } from './EdgeBase';

export default function DependencyEdge(props: EdgeProps<EdgeFlowEdge>) {
  return <EdgeBase {...props} />;
}
